import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdrlAPI } from '@api/modules/mdrl';
import { optnAPI } from '@api/modules/optn';
import pubPagination from '@/components/common/pubPagination';
import publicTips from '@/views/component/publicTips';
import helper from '@assets/js/helper.js';
export default {
  name: 'SmplEditBom',
  components: {
    pubPagination: pubPagination,
    publicTips: publicTips
  },
  data: function data() {
    return {
      tableData: [],
      searchForm: {
        mdrl_no: null,
        mdrl_name: null,
        mdrl_type: null,
        mdrl_color: null,
        colr_class: []
      },
      totalPage: 0,
      btn: {},
      loading: true,
      currentPage: 1,
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      title: '提示：相同数据仅限导入一条',
      optnColorList: []
    };
  },
  created: function created() {
    this.initData();
  },
  filters: {
    formatMdrlWidth: function formatMdrlWidth(row) {
      return helper.haveFour(row) + '米';
    },
    formatMdrlThick: function formatMdrlThick(row) {
      return helper.reservedDigits(row);
    },
    formaUnitH: function formaUnitH(row) {
      return helper.reservedDigits(row) + '毫米';
    }
  },
  methods: {
    initData: function initData() {
      this.getMdrlsList();
    },
    // 获取材料信息
    getMdrlsList: function getMdrlsList() {
      var _this = this;

      var searchBody = JSON.parse(JSON.stringify(this.searchForm));
      searchBody.page_no = this.currentPage;
      searchBody.status = 2;

      if (searchBody.colr_class.length > 0) {
        searchBody.colr_class = searchBody.colr_class.join(',');
      }

      get(mdrlAPI.getMdrls, searchBody).then(function (res) {
        if (res.data.code === 0) {
          _this.tableData = res.data.data.list;
          _this.totalPage = res.data.data.total;
          _this.btn = res.data.data.btn;
          setTimeout(function () {
            _this.loading = false;
          }, 300);
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this.$message({
            message: mg,
            type: tp
          });

          setTimeout(function () {
            _this.loading = false;
          }, 300);
        }
      });
    },
    // 清空
    clear: function clear() {
      this.$refs.multiTable.clearSelection();
    },
    // 查询方法
    getMdrlsNow: function getMdrlsNow() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.getMdrlsList();
    },
    // 刷新
    getMdrlsNowO: function getMdrlsNowO() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.searchForm = {
        mdrl_no: null,
        mdrl_name: null,
        mdrl_type: null,
        mdrl_color: null,
        colr_class: []
      }, this.getMdrlsList();
    },
    // 跳转材料信息表
    goMdrl: function goMdrl() {
      this.$emit('falseMdrl');
      this.jump("/mdrl_list?perm_id=".concat(this.helper.retPermId('mdrl')));
    },
    // 分页查询
    changePageSearch: function changePageSearch(val) {
      this.currentPage = val;
      this.getMdrlsList();
    },
    formatPic: function formatPic(scope, type) {
      var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
      return this.helper.picUrl(scope.row.imge_url, type, updateTime);
    },
    // 材料类型
    formatLeavType: function formatLeavType(row) {
      if (row.mdrl_type === 1) {
        return '钢材';
      } else if (row.mdrl_type === 2) {
        return '辅材';
      }
    },
    // 时间转换
    formatDate: function formatDate(row) {
      return this.helper.toStringDate(row.create_time);
    },
    // 取消选择
    cancel: function cancel() {
      this.$emit('mdrlChanel', false);
    },
    // 确认选择
    confirmIn: function confirmIn(val) {
      this.$emit('mdrlConfirm', val);
    }
  }
};